/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Enrich_Phase2_TranslateInputs */

const en_directory_submit_enrich_phase2_translate = /** @type {(inputs: Directory_Submit_Enrich_Phase2_TranslateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Translating & saving draft`)
};

const zh_directory_submit_enrich_phase2_translate = /** @type {(inputs: Directory_Submit_Enrich_Phase2_TranslateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译并保存草稿`)
};

/**
* | output |
* | --- |
* | "Translating & saving draft" |
*
* @param {Directory_Submit_Enrich_Phase2_TranslateInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_enrich_phase2_translate = /** @type {((inputs?: Directory_Submit_Enrich_Phase2_TranslateInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Enrich_Phase2_TranslateInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_enrich_phase2_translate(inputs)
	return zh_directory_submit_enrich_phase2_translate(inputs)
});
export { directory_submit_enrich_phase2_translate as "directory.submit.enrich.phase2.translate" }